export default __webpack_public_path__ + "static/media/Rihanna_9781408303528.9f7bb03d.jpg";